import { __decorate } from "tslib";
import { I18nThemed } from 'interfaces/mixins';
import { w, v } from '@dojo/framework/core/vdom';
import { storeInject } from '@dojo/framework/stores/StoreInjector';
import { TopicHead } from 'book-widgets';
function getProperties(store) {
    const { get, path } = store;
    return {
        topics: get(path('topics'))
    };
}
let LPTopicRoot = class LPTopicRoot extends I18nThemed {
    render() {
        const { classes = [], name = '', topicroot = '', topics } = this.properties;
        const gotData = () => {
            const topicdef = topics[topicroot];
            const { attributes = {}, children = [] } = topicdef.topichead;
            return w(TopicHead, { key: name, topic: { attributes, children } });
        };
        return topics ? gotData() : v('div', { classes, key: name, xqa: `lptopicroot ${name}` });
    }
};
LPTopicRoot = __decorate([
    storeInject({
        name: 'lcc-state',
        paths: [['topics']],
        getProperties
    })
], LPTopicRoot);
export { LPTopicRoot };
export default LPTopicRoot;
